export default function Config() {
    return (
        <div>
            <h1>Config</h1>
        </div>
    );
}